import React from 'react';
import styles from './UnitSidebar.module.css';

const UnitSidebar = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { key: 'overview', label: 'Unit Description' },
    { key: 'roommates', label: 'Roommates' },
    { key: 'amenities', label: 'Amenities' },
    { key: 'images', label: 'Images' },
    { key: 'tour', label: 'Tour' },
    { key: 'lease', label: 'Lease' },
  ];

  return (
    <div className={styles.sidebar}>
      <nav className={styles.nav}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`${styles.navBtn} ${activeTab === tab.key ? styles.active : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default UnitSidebar;
